<template>
  <div class="layout" id="top">
    <i-layout>
      <!-- ヘッダー -->
      <LayoutHeader />
      <!-- コンテンツ -->
      <i-content class="layout-content">
        <div class="layout-container">
          <router-view></router-view>
        </div>
      </i-content>
    </i-layout>
    <!--ローディング-->
    <Loading />
    <!-- TOPへ戻るボタン -->
    <ScrollTop />
    <!-- 物件新規登録モーダル -->
    <ModalNewPropertyLinkList />
    <!-- 物件確認モーダル -->
    <ModalHappyCall />
    <!-- 認証モーダル -->
    <ModalAuth />
    <!-- マイソクExcel出力モーダル -->
    <ModalMaisokuOutput />
    <!-- 一括削除モーダル -->
    <ModalPropertyBulkDelete />
    <!-- コンバートエラーモーダル -->
    <ModalConvertError />
    <!-- コンバート履歴モーダル -->
    <ModalConvertHistory />
    <!-- コンバート結果モーダル -->
    <ModalConvertDetail />
    <!-- 画像プレビューモーダル -->
    <ModalImagePreview />
  </div>
</template>

<script>
import { Layout, Content } from 'view-design'
import LayoutHeader from '@/components/globals/Header'
import Loading from '@/components/globals/Loading'
import ScrollTop from '@/components/globals/ScrollTop'
import ModalNewPropertyLinkList from '@/components/templates/modal/NewPropertyLinkList'
import ModalHappyCall from '@/components/templates/modal/HappyCall'
import ModalAuth from '@/components/templates/modal/Auth'
import ModalMaisokuOutput from '@/components/templates/modal/MaisokuOutput'
import ModalPropertyBulkDelete from '@/components/templates/modal/PropertyBulkDelete'
import ModalConvertError from '@/components/templates/modal/ConvertError'
import ModalConvertHistory from '@/components/templates/modal/ConvertHistory'
import ModalConvertDetail from '@/components/templates/modal/ConvertDetail'
import ModalImagePreview from '@/components/templates/modal/ImagePreview'
import UserRepository from '@/repositories/userRepository'
import MasterRepository from '@/repositories/masterRepository'
import SettingRepository from '@/repositories/settingRepository'
export default {
  components: {
    'i-layout': Layout,
    'i-content': Content,
    LayoutHeader,
    Loading,
    ScrollTop,
    ModalNewPropertyLinkList,
    ModalHappyCall,
    ModalAuth,
    ModalMaisokuOutput,
    ModalPropertyBulkDelete,
    ModalConvertError,
    ModalConvertHistory,
    ModalConvertDetail,
    ModalImagePreview,
  },
  data() {
    return {}
  },
  async created() {
    await this.init()
  },
  computed: {
    user: {
      get() {
        return this.$store.getters['User/getUser']
      },
      set(val) {
        this.$store.commit('User/setUser', val)
      },
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
  },
  methods: {
    // 初期処理
    init() {
      this.getUser()
      this.getMaster()
      this.getYearList()
      this.getPermissions()
    },
    async getUser() {
      await UserRepository.get()
        .then(data => {
          if (data.result) {
            const user = data.data
            // 権限チェック
            if (this.$route.name === 'residence-list' && !user.can_use_sale_residence) {
              this.$router.push({ name: `error` })
              window.location.href = 'https://manager.fudo-3.com'
            }
            if (this.$route.name === 'investment-list' && !user.can_use_sale_investment) {
              this.$router.push({ name: `error` })
              window.location.href = 'https://manager.fudo-3.com'
            }
            this.user = user
          } else {
            this.$router.push({ name: `error` })
          }
        })
        .catch(() => {
          this.$router.push({ name: `error` })
        })
        .finally(() => {})
    },
    async getMaster() {
      await MasterRepository.get()
        .then(data => {
          if (data.result) {
            this.$store.commit('Master/setMaster', data.data)
          } else {
            this.$router.push({ name: `error` })
          }
        })
        .catch(() => {
          this.$router.push({ name: `error` })
        })
        .finally(() => {})
    },
    async getYearList() {
      const nowYear = new Date().getFullYear()
      await MasterRepository.getYears(10, nowYear - 1970)
        .then(data => {
          if (data.result) {
            this.$store.commit('Master/setYear', data.data)
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },
    async getPermissions() {
      await SettingRepository.getPermissions()
        .then(data => {
          if (data.result) {
            this.$store.commit('User/setPermissions', data.data)
          } else {
            this.$router.push({ name: `error` })
          }
        })
        .catch(() => {
          this.$router.push({ name: `error` })
        })
        .finally(() => {})
    },
  },
}
</script>
<style lang="scss">
.layout {
  min-width: 1180px;
  margin: 0 auto;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  &-content {
    background-color: #f5f7fb;
    min-height: calc(100vh - 48px);
  }
  &-container {
    padding: 16px;
  }
}
</style>
